import React, { useState } from "react";
import { Box, Chip, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  domainChip: {
    cursor: "pointer",
    borderRadius: 50,
    padding: "8px 12px",
    backgroundColor: theme.palette.background.light,
    height: 36,
  },
  activeDomainChip: {
    backgroundColor: theme.palette.selection,
    border: `1px solid ${theme.palette.lightColor}`,
    margin: "-1px",
  },
  gradientText: {
    background: theme.palette.light,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  countChip: {
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.light : "#C5CAE9",
    fontWeight: 500,
  },
}));

function Domains({ selectedDomain, onDomainChange }) {
  const { classes } = useStyles();
  const { domains } = useSelector((state) => state.domain);
  return (
    <Box display={"flex"} alignItems={"center"} gap={1.5}>
      <Box
        className={`${classes.domainChip} ${
          selectedDomain === "all" ? classes.activeDomainChip : ""
        }`}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
        onClick={() => onDomainChange("all")}>
        <Typography variant="body2">
          <span
            className={selectedDomain === "all" ? classes.gradientText : ""}>
            All Plants
          </span>
        </Typography>
        <Chip
          size="small"
          label={domains.length}
          className={classes.countChip}
        />
      </Box>
      {domains.map((domain) => {
        return (
          <Box
            key={domain.id}
            className={`${classes.domainChip} ${
              selectedDomain === domain.domain ? classes.activeDomainChip : ""
            }`}
            onClick={() => onDomainChange(domain.domain)}>
            <Typography variant="body2">
              <span
                className={
                  selectedDomain === domain.domain ? classes.gradientText : ""
                }>
                {domain.domain}
              </span>
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

export default Domains;
